import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { toast } from "sonner";
import { 
  Target, 
  ChevronDown 
} from "lucide-react";

const PrioritiesSection = ({ userId, onRefresh }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const priorityContacts = [
    { company: "AT&T", name: "John Smith", title: "CFO" },
    { company: "Coca Cola", name: "Sara Jones", title: "CTO" },
    { company: "Datadog", name: "Jeff Wilson", title: "CIO" },
    { company: "Airbnb", name: "Brian Chesky", title: "CEO" },
    { company: "OpenAI", name: "Sam Altman", title: "CEO" },
    { company: "Dropbox", name: "Drew Houston", title: "CEO" },
    { company: "Databricks", name: "Ali Ghodsi", title: "CEO" }
  ];

  const handlePriorityClick = (contact) => {
    toast.info(`Opening meeting brief for ${contact.name} at ${contact.company}`);
  };

  return (
    <Card 
      className="bg-[#0f1419] border-gray-800/50 p-6 cursor-pointer transition-all duration-300 overflow-hidden"
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
      onClick={() => setIsExpanded(!isExpanded)}
      data-testid="priorities-section"
      style={{ height: isExpanded ? '600px' : '140px' }}
    >
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-white mb-1 flex items-center gap-2">
              <Target className="h-5 w-5 text-[#3dd9c5]" />
              Priorities
            </h2>
            <p className="text-sm text-gray-400">
              {isExpanded ? "Meeting brief generated for upcoming meeting with" : `${priorityContacts.length} upcoming priorities`}
            </p>
          </div>
          <ChevronDown 
            className={`h-5 w-5 text-gray-400 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
          />
        </div>
      </div>

      {/* Priority Cards */}
      <div className={`transition-all duration-300 ${isExpanded ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <ScrollArea className="flex-1 pr-4" style={{ height: isExpanded ? '450px' : '0' }}>
        <div className="space-y-2">
          {priorityContacts.map((contact, idx) => (
            <button
              key={idx}
              onClick={() => handlePriorityClick(contact)}
              className="w-full bg-white/5 backdrop-blur-sm border border-[#3dd9c5]/30 rounded-full px-4 py-3 hover:bg-white/10 hover:border-[#3dd9c5]/50 transition-all text-left"
              data-testid={`priority-card-${idx}`}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-white truncate">
                    {contact.company}
                  </p>
                  <p className="text-xs text-gray-400 truncate">
                    {contact.name}, {contact.title}
                  </p>
                </div>
                <Badge className="bg-[#3dd9c5]/20 text-[#3dd9c5] border-[#3dd9c5]/50 text-xs ml-2">
                  Brief
                </Badge>
              </div>
            </button>
          ))}
        </div>
      </ScrollArea>
      </div>
    </Card>
  );
};

export default PrioritiesSection;
